import type { FC } from 'react';
import React, { useMemo } from 'react';

import { IconPin, IconTruck } from '../../../assets/icons/icons';
import { useRegions } from '../../../hooks/useRegions';
import { cx } from '../../../utils/cx';
import styles from './ProjectSettingsBar.module.scss';
import { Select } from '../../ui/Select/Select';

interface ProjectSettingsBarProps {
    region: string;
    onRegionChange: (value: string) => void;
    logisticsCount: number;
    address: string;
    onAddressChange: (value: string) => void;
    onAddressCommit: () => void;
    isDeliveryProcessing?: boolean;
    deliveryPending?: number;
}

export const ProjectSettingsBar: FC<ProjectSettingsBarProps> = ({
    region,
    onRegionChange,
    logisticsCount,
    address,
    onAddressChange,
    onAddressCommit,
    isDeliveryProcessing = false,
    deliveryPending = 0,
}) => {
    const regions = useRegions(region);
    const needsAddress = logisticsCount > 0 && !address.trim();

    const regionOptions = useMemo(
        () => regions.map((item) => ({ value: item, label: item })),
        [regions],
    );

    return (
        <div className={styles.bar}>
            <span className={styles.label}>
                <IconPin />
                Регион поиска
            </span>

            <Select
                className={styles.select}
                options={regionOptions}
                value={region}
                onChange={onRegionChange}
                aria-label="Регион поиска для всех позиций"
            />

            <span className={styles.hint}>применяется, если в заявке не прописан регион</span>

            <span className={styles.divider} />

            {logisticsCount > 0 ? (
                <div className={cx(styles.delivery, needsAddress && styles.need)}>
                    <span className={styles.label}>
                        <IconTruck />
                        Адрес доставки
                    </span>

                    <input
                        className={styles.input}
                        list="deliveryAddressList"
                        placeholder="Населённый пункт, улица, дом"
                        aria-label="Адрес доставки по заявке"
                        value={address}
                        onChange={(event) => onAddressChange(event.target.value)}
                        onBlur={() => address && onAddressCommit()}
                        disabled={isDeliveryProcessing}
                    />
                </div>
            ) : (
                <span className={styles.hint}>Адрес запросим, когда включите логистику</span>
            )}
        </div>
    );
};